(function (root, factory) {
  var createController = factory();
  var controller = createController();

  controller.createController = createController;

  if (typeof module === 'object' && module.exports) {
    module.exports = controller;
  }

  if (root) {
    root.ShopSimonCategoryPageNosto = controller;
  }
})(typeof window !== 'undefined' ? window : this, function () {
  var resultStateParameters = [
    'bestsellers',
    'brand',
    'brandtype',
    'category',
    'categoryoverride',
    'clr',
    'color',
    'colorhex',
    'discount',
    'earingstyle',
    'gemstone',
    'glassesframetype',
    'img',
    'jewelrymaterial',
    'jewelrytype',
    'justin',
    'luxe',
    'onedaypageviewvelocity',
    'orderby',
    'preloved',
    'price',
    'productcondition',
    'producttype',
    'producttyperoot',
    'q',
    'rootcategory',
    'scoringprofile',
    'sevendaypageviewvelocity',
    'sport',
    'sportsleague',
    'sportsteam',
    'thirtydaypageviewvelocity',
    'trendingtoday',
    'vectorizeterm',
    'watchfaceshape',
    'width',
    'womensdressskirtlength',
    'womensspecialsizetype'
  ];

  function isResultStateParameter(key, value) {
    var normalizedKey = key.toLowerCase();

    if (normalizedKey === 'page') {
      return value !== '1';
    }

    return resultStateParameters.indexOf(normalizedKey) > -1 ||
      normalizedKey.indexOf('fzy_') === 0 ||
      normalizedKey.slice(-4) === 'size';
  }

  function hasResultState(search) {
    var params = new URLSearchParams(search || '');
    var resultStateFound = false;

    params.forEach(function (value, key) {
      if (isResultStateParameter(key, value)) {
        resultStateFound = true;
      }
    });

    return resultStateFound;
  }

  function remove(documentRef) {
    var placement = documentRef &&
      documentRef.querySelector('[data-category-page-nosto]');

    if (!placement) {
      return false;
    }

    placement.remove();
    return true;
  }

  return function createController() {
    var hasStartedInitialFetch = false;

    return {
      handleSearchFetch: function (isInteraction, documentRef) {
        var shouldRemove = isInteraction || hasStartedInitialFetch;
        hasStartedInitialFetch = true;

        return shouldRemove ? remove(documentRef) : false;
      },
      hasResultState: hasResultState,
      remove: remove,
      suppressForInitialUrl: function (search, documentRef) {
        return hasResultState(search) ? remove(documentRef) : false;
      }
    };
  };
});
